<script>
  import { userStore } from "../../../stores/user.store";
  import { onMount } from "svelte";
  import { nastavVrstvy, nastavVsetkyVrstvy } from "./vrstvy.func";

  export let expanded = false;
  export let childNodes;
  export let name;
  export let input_type = "checkbox";
  export let ulozeneVrstvy = [];
  export let vsetkyVrstvy = false;

  let id = () => Math.floor(Math.random() * 9999999);
  const id1 = id();
  const id2 = id();
  const id3 = id();
</script>

<input type="checkbox" id="cb{id1}" bind:checked={expanded} />
<section class="box">
  <label class="box-title" for="cb{id1}"
    >{name}
    {#if childNodes}<small>(0/{childNodes.length})</small>{/if}</label
  >
  <label class="box-close" for="cb{id1}" />
  {#if input_type === "checkbox"}
    <div class="toggleAll">
      <input
        type="checkbox"
        id="toggle{id2}"
        on:change={vsetkyVrstvy
          ? (e) => vsetkyVrstvy(e)
          : (e) => nastavVsetkyVrstvy(e)}
      /><label class="toggle__icon" for="toggle{id2}" />
    </div>
  {/if}
  <div class="box-content">
    {#each childNodes as vrstva, i}
      {#if vrstva.childNodes && vrstva.childNodes.length}
        <svelte:self
          childNodes={vrstva.childNodes && vrstva.childNodes.length
            ? vrstva.childNodes
            : null}
          {...vrstva}
          {ulozeneVrstvy}
        />
      {:else}
        <div class="input-group">
          <!-- Toggle start -->
          <div class="toggle">
            <input
              type={input_type}
              class="vrstva"
              name="vrstva"
              id="toggle{id3 + i}"
              data-kod={vrstva.type && vrstva.internal_name
                ? vrstva.internal_name
                : null}
              data-typ={vrstva.type}
              data-input-type={vrstva.input_type}
              data-kod-url={vrstva.is_external
                ? vrstva.external_url
                : vrstva.layers
                ? vrstva.layers.join(",")
                : vrstva.internal_name}
              data-is-external={vrstva.is_external}
              data-is-baselayer={vrstva.is_baselayer}
              checked={ulozeneVrstvy.some(
                (ulozenaVrstva) => ulozenaVrstva.kod === vrstva.internal_name
              )}
              on:change={vrstva.onChange || (() => nastavVrstvy())}
            />
            <label class="toggle__icon" for="toggle{id3 + i}" />
            <label class="toggle__text" for="toggle{id3 + i}"
              >{vrstva.name}</label
            >
            {#if vrstva.legenda && vrstva.legenda.length}
              <span class="legenda">
                {#each vrstva.legenda as leg}
                  <span
                    class="leg"
                    style="background-color: #{leg.html_kod};"
                    title={leg.text}
                  />
                {/each}
              </span>
            {/if}
          </div>
          <!-- Toggle end -->
        </div>
      {/if}
    {/each}
  </div>
</section>

<style>
  .box-content {
    width: 100%;
    padding-right: 0;
  }
  .toggleAll {
    position: absolute;
    top: 0.25rem;
    right: 0;
  }
  small {
    font-size: 70%;
  }
  .legenda {
    margin-left: auto;
  }
  .legenda .leg {
    display: inline-block;
    width: 10px;
    height: 10px;
    margin-left: 2px;
  }
</style>
